import React from 'react'

export const Step1 = () => {
  return (
    <svg
      fill="none"
      height="50"
      viewBox="0 0 50 50"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.248 31.6V33.232H21.032V31.6H24.716V19.876C24.716 19.524 24.728 19.168 24.752 18.808L21.692 21.436C21.588 21.524 21.484 21.58 21.38 21.604C21.276 21.62 21.18 21.62 21.092 21.604C21.004 21.588 20.92 21.556 20.84 21.508C20.768 21.46 20.712 21.408 20.672 21.352L20 20.428L25.124 16H26.864V31.6H30.248Z"
        fill="#FF0458"
      />
      <path
        clipRule="evenodd"
        d="M25 2C12.2975 2 2 12.2975 2 25C2 37.7025 12.2975 48 25 48C37.7025 48 48 37.7025 48 25C48 12.2975 37.7025 2 25 2ZM0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z"
        fill="url(#paint0_linear)"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="49"
          x2="1"
          y1="1"
          y2="49"
        >
          <stop stopColor="#C01CA1" />
          <stop offset="1" stopColor="#FF044B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const Step2 = () => {
  return (
    <svg
      fill="none"
      height="50"
      viewBox="0 0 50 50"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.716 31.36C29.948 31.36 30.132 31.428 30.268 31.564C30.404 31.7 30.472 31.876 30.472 32.092V33.388H19V32.656C19 32.504 19.032 32.348 19.096 32.188C19.16 32.028 19.26 31.88 19.396 31.744L24.904 26.212C25.36 25.748 25.776 25.304 26.152 24.88C26.528 24.448 26.848 24.016 27.112 23.584C27.376 23.152 27.58 22.716 27.724 22.276C27.868 21.828 27.94 21.352 27.94 20.848C27.94 20.344 27.86 19.904 27.7 19.528C27.54 19.144 27.32 18.828 27.04 18.58C26.768 18.332 26.444 18.148 26.068 18.028C25.692 17.9 25.288 17.836 24.856 17.836C24.416 17.836 24.012 17.9 23.644 18.028C23.276 18.156 22.948 18.336 22.66 18.568C22.38 18.792 22.144 19.06 21.952 19.372C21.76 19.684 21.624 20.028 21.544 20.404C21.448 20.684 21.316 20.872 21.148 20.968C20.988 21.056 20.76 21.08 20.464 21.04L19.348 20.848C19.46 20.064 19.676 19.372 19.996 18.772C20.324 18.164 20.732 17.656 21.22 17.248C21.716 16.84 22.28 16.532 22.912 16.324C23.544 16.108 24.228 16 24.964 16C25.692 16 26.372 16.108 27.004 16.324C27.636 16.54 28.184 16.856 28.648 17.272C29.112 17.68 29.476 18.18 29.74 18.772C30.004 19.364 30.136 20.036 30.136 20.788C30.136 21.428 30.04 22.024 29.848 22.576C29.656 23.12 29.396 23.64 29.068 24.136C28.74 24.632 28.36 25.116 27.928 25.588C27.504 26.06 27.052 26.536 26.572 27.016L22.036 31.648C22.356 31.56 22.68 31.492 23.008 31.444C23.336 31.388 23.652 31.36 23.956 31.36H29.716Z"
        fill="#FF0458"
      />
      <path
        clipRule="evenodd"
        d="M25 2C12.2975 2 2 12.2975 2 25C2 37.7025 12.2975 48 25 48C37.7025 48 48 37.7025 48 25C48 12.2975 37.7025 2 25 2ZM0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z"
        fill="url(#paint0_linear)"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="49"
          x2="1"
          y1="1"
          y2="49"
        >
          <stop stopColor="#C01CA1" />
          <stop offset="1" stopColor="#FF044B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const Step3 = () => {
  return (
    <svg
      fill="none"
      height="50"
      viewBox="0 0 50 50"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.528 20.848C19.64 20.064 19.856 19.372 20.176 18.772C20.496 18.164 20.9 17.656 21.388 17.248C21.884 16.84 22.448 16.532 23.08 16.324C23.72 16.108 24.408 16 25.144 16C25.872 16 26.544 16.104 27.16 16.312C27.776 16.52 28.304 16.816 28.744 17.2C29.192 17.584 29.54 18.048 29.788 18.592C30.036 19.136 30.16 19.74 30.16 20.404C30.16 20.948 30.088 21.436 29.944 21.868C29.808 22.292 29.608 22.664 29.344 22.984C29.088 23.304 28.776 23.576 28.408 23.8C28.04 24.024 27.628 24.208 27.172 24.352C28.292 24.64 29.132 25.136 29.692 25.84C30.26 26.536 30.544 27.408 30.544 28.456C30.544 29.248 30.392 29.96 30.088 30.592C29.792 31.224 29.384 31.764 28.864 32.212C28.344 32.652 27.736 32.992 27.04 33.232C26.352 33.464 25.612 33.58 24.82 33.58C23.908 33.58 23.128 33.468 22.48 33.244C21.832 33.012 21.284 32.696 20.836 32.296C20.388 31.896 20.02 31.424 19.732 30.88C19.444 30.328 19.2 29.732 19 29.092L19.924 28.708C20.164 28.604 20.396 28.576 20.62 28.624C20.852 28.672 21.02 28.804 21.124 29.02C21.228 29.244 21.356 29.512 21.508 29.824C21.668 30.136 21.884 30.436 22.156 30.724C22.428 31.012 22.772 31.256 23.188 31.456C23.612 31.656 24.148 31.756 24.796 31.756C25.396 31.756 25.92 31.66 26.368 31.468C26.824 31.268 27.2 31.012 27.496 30.7C27.8 30.388 28.028 30.04 28.18 29.656C28.332 29.272 28.408 28.892 28.408 28.516C28.408 28.052 28.348 27.628 28.228 27.244C28.108 26.86 27.884 26.528 27.556 26.248C27.228 25.968 26.776 25.748 26.2 25.588C25.632 25.428 24.9 25.348 24.004 25.348V23.8C24.74 23.792 25.364 23.712 25.876 23.56C26.396 23.408 26.816 23.2 27.136 22.936C27.464 22.672 27.7 22.356 27.844 21.988C27.996 21.62 28.072 21.212 28.072 20.764C28.072 20.268 27.992 19.836 27.832 19.468C27.68 19.1 27.468 18.796 27.196 18.556C26.924 18.316 26.6 18.136 26.224 18.016C25.856 17.896 25.456 17.836 25.024 17.836C24.592 17.836 24.188 17.9 23.812 18.028C23.444 18.156 23.116 18.336 22.828 18.568C22.548 18.792 22.312 19.06 22.12 19.372C21.928 19.684 21.792 20.028 21.712 20.404C21.608 20.684 21.476 20.872 21.316 20.968C21.164 21.056 20.94 21.08 20.644 21.04L19.528 20.848Z"
        fill="#FF0458"
      />
      <path
        clipRule="evenodd"
        d="M25 2C12.2975 2 2 12.2975 2 25C2 37.7025 12.2975 48 25 48C37.7025 48 48 37.7025 48 25C48 12.2975 37.7025 2 25 2ZM0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z"
        fill="url(#paint0_linear)"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="49"
          x2="1"
          y1="1"
          y2="49"
        >
          <stop stopColor="#C01CA1" />
          <stop offset="1" stopColor="#FF044B" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export const Step4 = () => {
  return (
    <svg
      fill="none"
      height="50"
      viewBox="0 0 50 50"
      width="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.484 26.992V19.9C27.484 19.692 27.492 19.464 27.508 19.216C27.524 18.968 27.548 18.716 27.58 18.46L21.316 26.992H27.484ZM31.96 26.992V28.216C31.96 28.344 31.92 28.452 31.84 28.54C31.768 28.628 31.652 28.672 31.492 28.672H29.356V33.196H27.484V28.672H19.852C19.692 28.672 19.552 28.628 19.432 28.54C19.32 28.444 19.248 28.328 19.216 28.192L19 27.1L27.364 16H29.356V26.992H31.96Z"
        fill="#FF0458"
      />
      <path
        clipRule="evenodd"
        d="M25 2C12.2975 2 2 12.2975 2 25C2 37.7025 12.2975 48 25 48C37.7025 48 48 37.7025 48 25C48 12.2975 37.7025 2 25 2ZM0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z"
        fill="url(#paint0_linear)"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="49"
          x2="1"
          y1="1"
          y2="49"
        >
          <stop stopColor="#C01CA1" />
          <stop offset="1" stopColor="#FF044B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const Logo = () => {
  return (
    <svg
      fill="none"
      height="56"
      viewBox="0 0 52 56"
      width="52"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1309 33C12.1876 35.6118 15.9484 37.204 11.6131 45.4928L5 55.7054C5 55.7054 7.46333 56.4167 8.10571 55.6288C13.4926 49.0213 16.4147 42.7253 19.9576 42.0851C23.7208 41.4061 26.3838 40.5247 27 39.106C27 39.1061 20.4111 39.5147 14.1309 33Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M44.06 7.27624C45.1979 8.07024 46.9176 9.26997 45.5309 11.9035L45.5225 11.9184C42.8629 16.3385 43.1254 24.784 43.3383 28C44.2526 25.7915 46.1401 23.6201 47.975 21.5096C50.117 19.0455 52.1403 16.7181 51.9924 14.919C51.9389 14.2687 51.6004 13.7068 50.9576 13.2007C49.5596 12.0151 49.1465 10.7864 48.6236 9.23056C48.1777 7.90432 47.6725 6.40122 46.4268 4.42755C45.8375 3.49365 45.2809 3 44.8175 3C43.9658 3 43.3206 4.67892 43 6.25315C43.0614 6.57949 43.5471 6.91831 44.06 7.27624Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M30.0036 41.2582C29.7823 41.0845 29.5195 41 29.2005 41C28.1422 41 26.894 41.9603 26.7553 42.0698L26.684 42.1261L26.6729 42.1267C26.2505 42.4124 26.0248 42.637 26.0019 42.7944C25.9785 42.9556 26.1774 43.1939 26.429 43.4955C27.1673 44.3797 28.5003 45.9768 28.075 50C30.6609 46.9306 31.0963 44.7161 30.9842 43.3691C30.8765 42.0755 30.2625 41.4619 30.0036 41.2582Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M7.78827 34C7.78877 34 7.78877 34 7.78926 34C8.80998 34 9.88796 33.8424 11 33.5313C10.8613 33.3918 10.6835 33.2065 10.4538 32.9598C9.95419 32.423 9.19381 31.5567 8.40892 30.4779C7.025 28.5758 5.31481 25.6545 5.02629 22.5389C4.63898 18.59 2.06772 18 0.569565 18C0.421372 18 0.222488 18.006 0 18.0283C0.836371 19.3896 2.8288 23.1961 0.843542 25.8302C0.14889 26.7304 0.0693158 28.1193 0.628722 29.5482C1.43283 31.6019 3.79066 34 7.78827 34Z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M13 35.0026C12.8872 35.0006 12.7849 35 12.7042 35C11.7407 35 9.36232 35.089 8.0888 35.9122C6.51004 36.9408 2.97672 39.6957 4.28479 43.0409C4.50064 43.5881 4.63968 43.8625 4.72544 44C4.80661 43.8233 4.90578 43.5235 4.99638 43.2497C5.35791 42.1571 5.90462 40.506 7.23165 39.2787C8.37786 38.2122 9.49133 38.0479 10.3859 37.9159C11.6642 37.7269 12.5246 37.5998 13 35.0026Z"
        fill="url(#paint4_linear)"
      />
      <path
        d="M30.2695 36.9999C34.6124 36.9997 39.8501 35.3371 40.1399 27.4186C40.188 26.0986 40.2279 24.9062 40.2641 23.8256C40.5351 15.7449 40.5995 13.8251 42.2835 11.4346C42.9876 10.4202 43.1909 9.34577 42.8126 8.63236C42.5672 8.16937 42.1048 7.92471 41.4758 7.92471C40.8284 7.92471 40.0338 8.19203 39.1777 8.69792C36.8256 10.0779 34.9563 10.6931 33.1157 10.6931C32.3166 10.6931 31.4894 10.5777 30.5124 10.3298C30.1655 10.2419 29.8225 10.1973 29.4933 10.1973C27.4589 10.1973 25.6881 11.9176 24.2301 15.3104C23.6623 16.6275 23.1511 17.7484 22.7 18.7373C21.5793 21.1942 20.6942 23.1349 19.7108 26.3583C19.6822 26.4667 19.5994 26.5315 19.5551 26.5664L19.5119 26.6012C19.2245 26.8031 18.9812 26.9013 18.7684 26.9013C18.5777 26.9013 18.416 26.8241 18.3007 26.6778C18.1111 26.4376 17.9485 25.9423 18.3766 24.2302C18.5412 23.5707 18.5244 23.3587 18.514 23.3058L18.4358 23.2226L18.4657 23.0821C19.5581 17.9533 22.2923 12.9153 24.4869 9.9107C26.4428 7.21374 27.8081 7.36907 29.658 7.56475C30.1987 7.6219 30.8117 7.6868 31.5021 7.6868C33.1859 7.6868 34.8694 7.29544 36.8003 6.45523C39.0351 5.46301 39.4513 4.73612 39.4066 4.30109C39.2603 2.87804 34.5117 1.83641 32.4839 1.39154C32.2632 1.34312 32.0618 1.29901 31.8855 1.25899C31.2342 1.11748 30.562 0.882992 29.912 0.656247C28.9447 0.318726 28.0311 0 27.2594 0C26.4916 0 25.5628 0.278043 25.1918 2.44589C24.3931 7.03741 22.8065 8.66454 18.1213 11.5317C13.9709 14.0664 11.3123 18.7248 11.0089 23.9929C10.9397 25.1871 11.2728 26.3582 11.9992 27.4738L12.0903 27.6139L12.0803 27.6317C13.6788 30.3725 20.7181 35.0597 25.0576 36.2414C25.0772 36.247 25.0912 36.2522 25.1051 36.2574C26.0531 36.5342 27.9909 37 30.2684 37C30.2688 36.9999 30.2691 36.9999 30.2695 36.9999Z"
        fill="url(#paint5_linear)"
      />
      <path
        d="M9.41485 8.11213C9.1098 13.6975 8.98425 17.9105 9.00157 20C9.48915 18.2304 10.1939 16.3268 11.5213 14.2623C13.2009 11.671 17.5444 8.91937 19.9839 7.50973C21.4971 6.64452 23.1054 4.51445 22.9946 2.95785C22.9406 2.19996 22.4835 1.64378 21.636 1.30454C21.13 1.09948 20.6992 1 20.3175 1C19.5965 1 19.1717 1.36794 18.722 1.75755C18.2703 2.14889 17.8032 2.55337 17.059 2.55337C16.809 2.55337 16.5492 2.50773 16.2649 2.41355C15.3075 2.09737 14.4852 1.94371 13.7511 1.94371C11.0989 1.94371 9.63997 4.01903 9.41485 8.11213Z"
        fill="url(#paint6_linear)"
      />
      <path
        d="M50.8147 30.0898C50.2617 30.0477 49.6348 30 48.9471 30C46.8906 30 43.8955 30.3777 41.6382 33.6437C39.2784 37.0276 36.6569 37.5328 35.3044 37.5328C35.1977 37.5328 35.0961 37.5296 35 37.5243C36.3339 38.5042 37.7983 39 39.363 39C43.0461 39 46.2574 36.2712 47.2681 34.4272C48.1842 32.7999 49.9459 31.5978 51.1114 30.8023C51.4556 30.5674 51.8364 30.3073 52 30.1544C51.962 30.1516 51.9142 30.1494 51.8545 30.149C51.5618 30.1467 51.2156 30.1203 50.8147 30.0898Z"
        fill="url(#paint7_linear)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="18.979"
          x2="-7.77896"
          y1="37.9431"
          y2="75.9209"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear"
          x1="45.8442"
          x2="51.9082"
          y1="21.7259"
          y2="17.6433"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear"
          x1="28.0741"
          x2="12.9843"
          y1="46.2747"
          y2="65.7423"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear"
          x1="7.39104"
          x2="-0.9329"
          y1="29.8934"
          y2="24.3868"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint4_linear"
          x1="13.1345"
          x2="-10.2993"
          y1="32.5804"
          y2="60.2106"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint5_linear"
          x1="22.6996"
          x2="37.3346"
          y1="34.3668"
          y2="4.50168"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint6_linear"
          x1="17.4426"
          x2="10.6074"
          y1="17.496"
          y2="1.68703"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint7_linear"
          x1="35.3779"
          x2="48.9045"
          y1="35.7708"
          y2="28.5735"
        >
          <stop stopColor="#C21C8A" />
          <stop offset="1" stopColor="#F50F4C" />
        </linearGradient>
      </defs>
    </svg>
  )
}
